// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_NFq","cls2":"ProfileDropdown-cls2_LZh ProfileDropdown-cls1_NFq"};